export default __webpack_public_path__ + "images/datatables_sort_desc.png?e8c4e0429b817065ffda4a872aa234c2";